import initApp from './initApp';
initApp();
